import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import AccountCodePicker, { accountCodeType } from './AccountCodePicker'

// An account segment's filter (Org, Object, Segment One…) as a FilterEditor, for the AND/OR group
// builder. Writes the same <codeType>/<codeType>Operator values the column header does, plus
// each code's name and code under accountCodeLabels, so a saved filter reads as names, not ids.
const AccountSegmentFilterPopover = ({ column, params, setParams, onClose, onSetHandleApply, canEdit = true }) => {
  const accountType = column.database_column_name
  const codeType = accountCodeType(accountType)
  const operatorKey = `${codeType}Operator`
  const [ids, setIds] = useState(params[codeType] || [])
  const [operator, setOperator] = useState(params[operatorKey] || 'include')
  const [labels, setLabels] = useState(params.accountCodeLabels || {})

  const apply = () => {
    setParams((current) => ({
      ...current,
      [codeType]: ids,
      [operatorKey]: operator,
      accountCodeLabels: Object.fromEntries(ids.filter((id) => labels[id]).map((id) => [id, labels[id]]))
    }))
    onClose?.()
  }

  useEffect(() => {
    onSetHandleApply?.(apply)
  }, [ids, operator, labels]) // eslint-disable-line react-hooks/exhaustive-deps

  const toggleCode = (accountCode, checked) => {
    setIds((current) => (checked ? [...current, accountCode.id] : current.filter((id) => id !== accountCode.id)))
    if (checked) setLabels((current) => ({ ...current, [accountCode.id]: { name: accountCode.name, code: accountCode.code } }))
  }

  return (
    <AccountCodePicker
      accountType={accountType}
      selectedIds={ids}
      operator={operator}
      onToggleCode={toggleCode}
      onToggleOperator={() => setOperator((current) => (current === 'exclude' ? 'include' : 'exclude'))}
      onClearAll={() => {
        setIds([])
        setOperator('include')
      }}
      initialSelected={ids.filter((id) => labels[id]).map((id) => ({ id, ...labels[id] }))}
      canEdit={canEdit}
      actions={
        <Button size="sm" variant="primary" onClick={canEdit ? apply : onClose} data-testid="account-segment-apply">
          {canEdit ? 'Apply' : 'Close'}
        </Button>
      }
    />
  )
}

AccountSegmentFilterPopover.propTypes = {
  column: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  setParams: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onSetHandleApply: PropTypes.func,
  canEdit: PropTypes.bool
}

export default AccountSegmentFilterPopover
